let Flora = function ($http, SERVER_URL) {
  "ngInject";

  return {
    getList: getList,
    get: get,
    getTypes: getTypes,
    put: put,
    putStrings: putStrings,
    postStrings: postStrings
  }

  function getList() {
    return $http.get(SERVER_URL + "/flora-by-modified-date", {
      params: {modifiedDate: "2010-10-31T00:49:30.995Z"}
    })
  }

  function get(id) {
    return $http.get(SERVER_URL + "/flora/" + id)
  }

  function getTypes() {
    return ['PTERIDOFITE', 'SPERMATOFITE_ANGIOSPERME', 'SPERMATOFITE_GIMNOSPERME', 'ALTRO'];
  }

  function put(data){
    return $http.put(SERVER_URL + "/flora", data);
  }

  function postStrings(data){
    return $http.post(SERVER_URL + "/flora-strings", data);
  }

  function putStrings(data){
    return $http.put(SERVER_URL + "/flora-strings", data);
  }
}
export default Flora;



// WEBPACK FOOTER //
// ./client/app/services/floraService/flora.service.js